import React, {useEffect, useState} from 'react';

// icons
import { FaPaperPlane } from 'react-icons/fa'; // Import the icon from react-icons

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// styles
import { Colors, Spacing, Typography } from '_styles';

const MessageInput = (props) => {

    return (
        <Container>
              <Row className="d-flex justify-content-center">
                <div style={{ display:'flex' }}>
                  <Form.Control 
                    onChange={props.onChange} 
                    onKeyPress={props.onKeyPress} 
                    type="name" placeholder="Type your message..." 
                    style={{fontSize:18}} 
                    value={props.value} 
                  />  
                  <Button 
                    onClick={props.onClick} 
                    style={{  width:'auto', marginLeft:Spacing.SCALE_12}}>
                    <FaPaperPlane size={22} /> 
                  </Button>
                </div>
              </Row>
        </Container>
    );
};

export default MessageInput;
